import React from 'react'
import commonStyles from "../PaymentDrawer.styles"
import Icons from '../../../../components/icons/Icons'
import { VEC_ICON_NAME } from '../../../../components/icons/constants'
import Heading from '../../../../components/heading/Heading'
import { HEADING } from '../../../../components/heading/constants/constants'
import Label from '../../../../components/label/Label'
import styles from "./PaymentSuccess.styles"
import General from '../../../../../libs/utility/General'
import Loadable from '../../../../components/loadable/Loadable'
import { PAYMENT_DRAWER_LOADING_STATES, PAYMENT_DRAWER_MESSAGE_MAP } from '../constants'
import { useSelector } from 'react-redux'
import { componentKey } from '../PaymentDrawerSlice'
import Button from '../../../../components/button/Button'

export const PaymentSuccess = ({ isOpen = false, onCloseCb = () => { }, paymentSuccessDetails = {}, calculateEstimatedTax = false, successNavigationBtns = false, onSuccessNavigationBtnsArr = [] }) => {

    const { loadingState, payNowCbLoadingState } = useSelector(state => state[componentKey])

    const renderRedirectButtons = () => {
        if(successNavigationBtns && onSuccessNavigationBtnsArr.length){
            return <div style={styles.redirectBtnsContainer}>
                {onSuccessNavigationBtnsArr.map((button, index) => (
                    <Button
                        key={index}
                        type={button?.type}
                        style={button?.customStyle}
                        onClickCb={button?.onClickCb}
                    >
                        {button?.label}
                    </Button>
                ))}
            </div>
        }else{
            return null
        }
    }

    return (
        <Loadable
            currentState={payNowCbLoadingState?.state}
            loadingStates={[PAYMENT_DRAWER_LOADING_STATES.PAY_NOW_LOADING]}
            messageMap={PAYMENT_DRAWER_MESSAGE_MAP}
            isNewLoadable={true}
        >
            <div style={styles.paymentSuccess}>
                <Icons familyName="vec" iconName={VEC_ICON_NAME.PAYMENT_SUCCESS_DRAWER_ICON} />
                <Heading type={HEADING.H1} customStyle={styles.paymentText}>Payment successful!</Heading>

                <div style={styles.transactionDetails}>
                    {paymentSuccessDetails?.referenceId ?
                        <>
                            <Label customStyles={styles.transactionLabel}>{paymentSuccessDetails?.message ? paymentSuccessDetails?.message : "Details of transactions are included below."}</Label>
                            <Label customStyles={styles.transactionLabel}> Your transaction no. is - {paymentSuccessDetails?.referenceId}</Label>
                        </>

                        :

                        <>
                            {calculateEstimatedTax && <Label customStyles={styles.transactionLabel}>
                                {paymentSuccessDetails?.message && paymentSuccessDetails?.message || ""}
                            </Label>
                            }
                        </>
                    }
                </div>

                <div style={{ ...styles.transactionDetails, ...styles.columnGap }}>
                    <Heading type={HEADING.H1} customStyle={commonStyles.amount}>Total amount paid is ${General.getDecimalAmount(paymentSuccessDetails?.amountPaid)}</Heading>
                </div>
                {renderRedirectButtons()}
            </div>
        </Loadable>
    )
}
